import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Student {
  id: string;
  name: string;
  identifier: string;
}

interface TemporalUserData {
  email: string;
  cc: string;
  students: Student[];
}

interface TemporalUserState {
  data: TemporalUserData | null;
  isComplete: boolean;
}

const initialState: TemporalUserState = {
  data: null,
  isComplete: false,
};

const temporalUserSlice = createSlice({
  name: 'temporalUser',
  initialState,
  reducers: {
    setTemporalUserData: (state, action: PayloadAction<TemporalUserData>) => {
      state.data = action.payload;
      state.isComplete = !!(
        action.payload.email &&
        action.payload.cc &&
        action.payload.students.length > 0
      );
    },
    clearTemporalUserData: (state) => {
      state.data = null;
      state.isComplete = false;
    },
  },
});

export const { setTemporalUserData, clearTemporalUserData } = temporalUserSlice.actions;
export default temporalUserSlice.reducer;
